module.exports = __webpack_public_path__ + "assets/img/trust_10.b73839af.png";